import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetRegionsByCountryCode = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async ({ countryCode, validityDate }: { countryCode: string; validityDate: string }) => {
        const { data } = await send<Types.IGetRegionsByCountryCodeRequestData, Types.IGetRegionsByCountryCodeResponseData>({
            ID: 35893,
            responses: [35894, 35895],
            description: 'Get Regions By Country Code',
            casino: casinoName,
            countryCode,
            validityDate
        });

        return data;
    }, [send, casinoName]);
};
